import { CubeLoadQuery, readCubeDataRows, readCubeErrorMessage } from "./cubeQueryTypes";

export const cubeApiUrl = "https://cube.prod.megaron.eu";
const cubeLoadUrl = `${cubeApiUrl}/cubejs-api/v1/load`;

export const fetchCubeLoad = async (params: {
  cubeLoad: (query: CubeLoadQuery) => Promise<unknown>;
  query: CubeLoadQuery;
}): Promise<unknown> => {
  return params.cubeLoad(params.query);
};

export const postCubeLoad = async (query: CubeLoadQuery, authHeader: string | undefined): Promise<unknown> => {
  const res = await fetch(cubeLoadUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: authHeader ?? "" },
    body: JSON.stringify({ query }),
  });
  const json: unknown = await res.json();
  if (!res.ok) throw new Error(readCubeErrorMessage(json) ?? `HTTP ${res.status}`);
  return json;
};

export const getCubeDataOrThrow = (json: unknown): unknown[] => {
  const data = readCubeDataRows(json);
  if (data === undefined) throw new Error("Invalid Cube response: data");
  return data;
};
